import Loader from '../components/Loader/Loader'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetConfirmEmailMutation } from '../redux/api/userApi'
import { useEffect } from 'react'
import { PATH } from '../routes/constant'
import ErrorMessage from '../components/ErrorMessage'
import { setRouteParams } from '../utils/setRouteParams'
import { Box } from '@mui/material'

const ConfirmEmail = () => {
  const params = useParams()
  setRouteParams(params)
  const { id } = params
  const [confirmEmail, {
    isSuccess,
    error,
    isLoading
  }] = useGetConfirmEmailMutation()
  const navigate = useNavigate()

  useEffect(() => {
    if (isSuccess) {
      navigate(PATH.HOME, {
        replace: true,
        state: { isEmailChange: true }
      })
    }
  }, [isSuccess])

  useEffect(() => {
    const confirm = async () => {
      await confirmEmail({ token: id }).then().catch((e) => {
      })
    }
    void confirm()
  }, [])

  return <Box>
        <ErrorMessage error={error}/>
        {isLoading && <Box sx={{ marginTop: '150px' }}><Loader/></Box>}
    </Box>
}

export default ConfirmEmail
